'use strict';
var parent = require('../../stable/symbol');

require('../../modules/esnext.function.metadata');
require('../../modules/esnext.symbol.async-dispose');
require('../../modules/esnext.symbol.dispose');
require('../../modules/esnext.symbol.metadata');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/actual/symbol/index.js
// module id = 1226
// module chunks = 0